export default __webpack_public_path__ + "static/Saly-12-bbd5ad71224a118361f8a39f3276426e.png";